import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchTextState } from '../../redux/users'

class SearchField extends Component {

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    this.props.dispatch(searchTextState(this.refs.searchInput.value))
    this.props.callback()
  }

  componentDidMount() {
    if (this.props.users && this.props.users.previousSearchText) {
      this.setValue(this.props.users.previousSearchText)
    } else {
      this.setValue("")
    }
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder="Seach user details..."
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    users: state.users
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchField)


// WEBPACK FOOTER //
// ./src/modules/Users/Components/TableCustomComponents/SearchField.js